import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';
import createTagsActions, {
  ICreateTagsMeta,
} from 'store/actions/library/createTags';

export default createAsyncReducer<ICreateTagsMeta, GenericResponse>(
  createTagsActions,
);
